import { Text } from "./..";
import React from "react";

export function ContactUserIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M20 21a8 8 0 0 0-16 0M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ContactPhoneIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.1 9.64a16 16 0 0 0 6.26 6.26l1.19-1.19a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ContactPinIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ContactDetailsCard({
  contactName,
  contactPhone,
  contactLocation,
  onClose = null,
  compact = false, // tooltip vs modal
}) {
  const initial = (contactName || "S").trim().charAt(0) || "S";

  return (
    <div
      dir="rtl"
      className={`relative rounded-[18px] border border-gray-200 bg-white shadow-[0_10px_30px_rgba(0,0,0,0.14)] ${
        compact ? "w-[320px] p-4" : "w-[360px] max-w-[92vw] p-5"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {onClose && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          className="absolute left-3 top-3 text-gray-400 hover:text-gray-600 text-[28px] leading-none"
          aria-label="סגירה"
        >
          ×
        </button>
      )}

      <div className={`text-center font-heebo font-bold text-black ${compact ? "text-[20px]" : "text-[22px]"}`}>
        פרטי התקשרות
      </div>

      <div className="relative mt-4">
        <div className="space-y-2 pl-14">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactUserIcon />
              <span className="font-heebo text-[16px] font-semibold text-gray-700">שם איש קשר:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left break-words">{contactName || "-"}</span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactPhoneIcon />
              <span className="font-heebo text-[16px] font-semibold text-gray-700">טלפון:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left" dir="ltr">{contactPhone || "-"}</span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactPinIcon />
              <span className="font-heebo text-[16px] font-semibold text-gray-700">מיקום ההצעה:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left break-words">{contactLocation || "-"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// Backwards-compatible default export: the user icon
export default ContactUserIcon;

// Attach components for convenient namespaced access (optional)
ContactUserIcon.ContactPhoneIcon = ContactPhoneIcon;
ContactUserIcon.ContactPinIcon = ContactPinIcon;
ContactUserIcon.ContactDetailsCard = ContactDetailsCard;
